import { CSSProperties } from "react";

export default function createTheme(bodyHex: string, themeName: string, imageUrl: string): CSSProperties {
    //Read the background image from a JSON file and return a CSSProperties object
    try {
        const theme = (imageUrl || !themeName) ? null : require(`./themes/${themeName}.json`);
        const themeImage = theme?.backgroundImage && `url(${process.env.PUBLIC_URL}/images/Login/Patterns/${theme?.backgroundImage})`;
        const backgroundImageUrl = imageUrl ? `url(${imageUrl.trim()})` : themeImage;

        //console.log('backgroundImageUrl', backgroundImageUrl);

        if (!backgroundImageUrl && !theme?.backgroundColor && !bodyHex) return {};
        return {
            backgroundColor: theme?.backgroundColor || bodyHex,
            backgroundImage: backgroundImageUrl,
            backgroundRepeat: 'repeat',
        } as CSSProperties;

    } catch (e) {
        console.error(`Error loading theme: ${themeName}`, e);
        return {};
    }
}

